import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'trade-multi-order-error',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './multi-order-error.component.html',
  styleUrl: './multi-order-error.component.scss',
})
export class MultiOrderErrorComponent {
  @Input() public errors: string[];
}
